import { render } from "./CollectorsList.vue?vue&type=template&id=f2441f6e"
import script from "./CollectorsList.vue?vue&type=script&lang=js"
export * from "./CollectorsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__